// removed by extract-text-webpack-plugin
module.exports = {"locale-CN":"locale-CN","SideMenu":"SideMenu","menus--item":"menus--item","subMenus":"subMenus","SideMenu__hidden":"SideMenu__hidden","menus":"menus","active":"active","teaching":"teaching","finance":"finance","marketing":"marketing","school":"school","menus--item--icon":"menus--item--icon","menus--item--name":"menus--item--name","SideMenu--content":"SideMenu--content","menus--item--content":"menus--item--content","opened":"opened","SideMenu--hideToggle":"SideMenu--hideToggle"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/SideMenu/SideMenu.scss
// module id = se6L
// module chunks = 0